import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { UntypedFormControl, Validators, UntypedFormGroup } from "@angular/forms";
import { GroupDescriptor } from "@progress/kendo-data-query";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { EntityListAction, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { HrmAccVoucherCodeFormComponent } from "./hrm-acc-voucher-code-form.component";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
@Component({
  selector: 'hrm-acc-voucher-code',
  templateUrl: './hrm-acc-voucher-code.component.html',
  styleUrls: ['./hrm-acc-voucher-code.component.scss']
})
export class HrmAccVoucherCodeComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  public gridColumns: form_control[] = [];
  groups: GroupDescriptor[] = [{ field: "ElementGroupTitle" }, { field: "CostCenterTitle" }];
  editingName: { name: string };
  actions: EntityListAction[];
  PayCompaniesIds: number[] = [];
  model: any;
  DetailLedgerLevel: number = 0;
  pcColumns: form_control[] = [];
  filterInfo: NameValue[] = [];
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(
    private lookupservice: LookupService, protected cd: ChangeDetectorRef, private missetup: MisSetupService) {
    super();
    this.inputEditorform = HrmAccVoucherCodeFormComponent;
  }
  ngOnInit() {
    this.DetailLedgerLevel = this.missetup.getnumber("ACC", "DLLEVEL");
    this.apiName = "HrmAccVoucherCode/GetByHrmVouchrKindId";
    this.areaName = "Payroll";
    this.label = "ارتباط حسابها و عوامل";
    this.setColumns();
  }
  async setGridColumns() {
    if (!this.DetailLedgerLevel)
      this.DetailLedgerLevel = this.missetup.getnumber("ACC", "DLLEVEL");
    const data = await this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          if (data) {
            this.gridColumns = (data as form_control[]).sort((a, b) => a.order - b.order);
            this.gridColumns.forEach(x => {
              if (x.name.includes('DetailLedgerCode') ||
                x.name.includes('DetailLedgerTitle') ||
                x.name.includes('DetailLedgerKindTitle')) {
                x.listVisible = this.DetailLedgerLevel >= 1;
              }
              if (x.name.includes('DetailLedger2Code') ||
                x.name.includes('DetailLedger2Title') ||
                x.name.includes('DetailLedgerKind2Title')) {
                x.listVisible = this.DetailLedgerLevel >= 2;
              }
              if (x.name.includes('DetailLedger3Code') ||
                x.name.includes('DetailLedger3Title') ||
                x.name.includes('DetailLedgerKind3Title')) {
                x.listVisible = this.DetailLedgerLevel >= 3;
              }
              if (x.name.includes('DetailLedger4Code') ||
                x.name.includes('DetailLedger4Title') ||
                x.name.includes('DetailLedgerKind4Title')) {
                x.listVisible = this.DetailLedgerLevel >= 4;
              }
              if (x.name.includes('DetailLedger5Code') ||
                x.name.includes('DetailLedger5Title') ||
                x.name.includes('DetailLedgerKind5Title')) {
                x.listVisible = this.DetailLedgerLevel >= 5;
              }
            });
          }
        },
        (error) => console.log(error)
      );
  }
  setColumns() {
    this.setGridColumns();
    let group: any = {};
    this.model = {};
    this.columns = [];
    this.columns.push(<form_control>{ label: 'نوع سند', controlType: FormControlTypes.dropdown, modelName: 'HrmVouchrKindId', disabled: false, name: 'HrmVouchrKindId', order: 1, textType: 'text', formVisible: true, listVisible: true, required: true, columnNumber: 1, userClass: "select-sm", apiName: "Lookup", systemName: 'HRM', category: 'HrmVouchrKind', valueMember: 'Id', displayMember: 'Title' });
    this.lookupservice.getLookupbyCode("HRM", "HrmVouchrKind", 1).
      pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(rk => {
        this.filterInfo.push({ Name: 'HrmVouchrKindId', Value: rk.Id, Operator: 'eq' });
        this.filterInfo.push({ Name: 'HrmVouchrKindCode', Value: rk.Code, Operator: 'eq' });
        
        group['HrmVouchrKindId'] = new UntypedFormControl(rk.Id, Validators.required);
      });
    this.group = new UntypedFormGroup(group);
    this.model = this.getDataFromFormGroup(this.model);
    this.group.get('HrmVouchrKindId')
      .valueChanges
      .subscribe(x => {
        if (x) {
        var HrmVouchrKind = this.lookupservice.getLookupbyId(x);        
        this.filterInfo.find(x => x.Name === 'HrmVouchrKindId').Value = x;
        this.filterInfo.find(x => x.Name === 'HrmVouchrKindCode').Value = HrmVouchrKind.Code;
          if (this.grid) {
            this.grid.defaultFilterKey = this.filterInfo;
            this.grid.refreshData();
          }
        }
      });
    this.cd.markForCheck();
  }
}